module.exports = __webpack_public_path__ + "static/securedapp-section-mob-img-3ecd322bfc607af8d299e50024ead3b2.png";